import store from '@/store/index'
import router from '@/router'
import Api from '@/api/api';
import { request } from '@/assets/common_js_files/request';
let code = getUrlParam('code');

//登录指向的页面 修改这个就可以 --。
let login_page_root = ''

//登录成功后跳转的路由页面
//获取地址栏参数
export function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

// 登录
export function getLoginPage() {

    function getUrlParam1(variable) {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    }
    let redirectUrl = document.URL;

    if (redirectUrl.indexOf("&code") >= 0) {
        redirectUrl = redirectUrl.replace("&code=" + code, "");
    } else {
        redirectUrl = redirectUrl.replace("?code=" + code, "");
    }

    let paramStr = ''
    let login_page = getUrlParam1('login_page')

    if (login_page && login_page != '') {
        sessionStorage.setItem("login_page", login_page)
        paramStr += '?login_page=' + login_page;
    } else {
        if (redirectUrl.indexOf('?login_page') == -1) {
            let logout_page = sessionStorage.getItem('login_page')
            paramStr += `?login_page=${logout_page}`
        }
    }

    let u = getUrlParam1('u')

    if (u && u != '') {
        if (paramStr) {
            paramStr += '&';
        }
        paramStr += 'u=' + u;
    }

    let p = getUrlParam1('p')

    if (p && p != '') {
        if (paramStr) {
            paramStr += '&';
        }
        paramStr += 'p=' + p;
    }

    let newUrl = redirectUrl
    newUrl = newUrl.replace(/\?.*#/g, '#')
    redirectUrl = newUrl + paramStr;

    console.log("最新", redirectUrl, newUrl);

    redirectUrl = encodeURIComponent(redirectUrl);
    // newUrl = encodeURIComponent(newUrl)
    if (!code || code == "") {
        window.location = Api.logIn + "client_id=appid&redirect_uri=" + redirectUrl + "&response_type=code&scope=read";
    } else {
        if (sessionStorage.getItem('userInfo')) {
            //向vuex中提交登录状态 登录状态在路由 前置路由守卫中判断是否登录

            store.commit("setLoginStatus", true);

            let user_info = JSON.parse(sessionStorage.getItem('userInfo'))

            router.push({
                path: "/home"
            });

            let name = sessionStorage.getItem('pathName')

            if(name) {
                router.push({ name })
                // sessionStorage.setItem('pathName','')
            }
            //用户信息 刷新页面时vuex是不可访问的 把变量放在sessionStorage 如果登录状态没有失效 就直接取
            store.commit("setUserInfo", JSON.parse(sessionStorage.getItem('userInfo')));
        } else {
            // redirectUrl = encodeURIComponent(redirectUrl);
            //获取用户
            getUser(redirectUrl);
        }

    }

}

// 登出
export function logout() {
    function getUrlParam1(variable) {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] == variable) return pair[1];
        }
        return (false);
    }

    let redirectUrl = document.URL;
    localStorage.removeItem('origin_userInfo')
    sessionStorage.removeItem('userInfo')

    if (redirectUrl.indexOf("&code") >= 0) {
        redirectUrl = redirectUrl.replace("&code=" + code, "");
    } else {
        redirectUrl = redirectUrl.replace("?code=" + code, "");
    }

    redirectUrl = encodeURIComponent(redirectUrl);
    store.commit("setLoginStatus", false);
    window.location = Api.logOut + redirectUrl;
}

//业务代码 获取用户信息
function getUser(redirectUrl) {
    /** 业务逻辑 根据业务写 */
    let params = {
        code: code,
        redirect_uri: redirectUrl,
    };
    //获取用户信息
    request({
        method: 'get',
        url: Api.getUserInfo,
        params
    }).then(result => {
        console.log("用户信息：", result);
        if (result && result.errCode == "0") {
            //获取成功 方法
            store.commit("setUserInfo", result);

            //用户信息 刷新页面时vuex是不可访问的 把变量放在sessionStorage 如果登录状态没有失效 就直接取
            sessionStorage.setItem('userInfo', JSON.stringify(result));

            //向vuex中提交登录状态 登录状态在路由 前置路由守卫中判断是否登录
            store.commit("setLoginStatus", true);

            let user_info = JSON.parse(sessionStorage.getItem('userInfo'))

            router.push({ path: "/home" });
            // if (user_info.type === 0) {
            //     // router.push({ path: "/home" });
            // } else {
            //     // router.push({ path: "/" });
            // }
        } else {
            console.log('获取用户失败');
            window.location = Api.logOut + redirectUrl;
        }
    }).catch((err) => {
        console.log('获取用户信息失败:>>>>>',err);
    });
}
